import React from "react";
import PropTypes from "prop-types";
import "./filter-section.scss";

const FilterSection = ({ children }) => {
  return <ul className="filter-section-container">{children}</ul>;
};

FilterSection.defaultProps = {};
FilterSection.propTypes = { children: PropTypes.node.isRequired };

export default FilterSection;
